<script setup>
import { computed } from 'vue';
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';
import { formatTime } from '@chatwoot/utils';

const props = defineProps({
  collection: {
    type: Object,
    default: () => ({}),
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
});

ChartJS.register(Title, Tooltip, BarElement, CategoryScale, LinearScale);

const fontFamily =
  'Inter,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

// Custom function for tooltip
function myCustomTooltip(value) {
  if (value.dataset.label.includes('Tempo')) {
    return formatTime(value.raw);
  }
  return value.raw;
}

const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      labels: {
        font: {
          family: fontFamily,
        },
      },
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          return myCustomTooltip(context);
        },
      },
    },
  },
  animation: {
    duration: 0,
  },
  datasets: {
    bar: {
      barPercentage: 1.0,
    },
  },
  scales: {
    x: {
      ticks: {
        font: {
          family: fontFamily,
        },
      },
      grid: {
        drawOnChartArea: false,
      },
    },
    y: {
      type: 'linear',
      position: 'left',
      ticks: {
        font: {
          family: fontFamily,
        },
        beginAtZero: true,
        stepSize: 1,
        callback: function (value) {
          return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
      },
      grid: {
        drawOnChartArea: false,
      },
    },
  },
};

const options = computed(() => {
  return {
    ...defaultChartOptions,
    ...props.chartOptions,
    plugins: {
      ...defaultChartOptions.plugins,
      ...(props.chartOptions.plugins || {}),
    },
  };
});
</script>

<template>
  <Bar :data="collection" :options="options" />
</template>
